import { jsx as a } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import p from "../../../FormFields/InputBase.js";
/* empty css                  */
import { useState as v, useCallback as x, useEffect as T, useMemo as h } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import N from "../../../../../core/Context/useCoreContext.js";
import { AMOUNT_MULTIPLIER as b } from "./constants.js";
import { isUndefined as m } from "../../../../../utils/value/is.js";
import { CommitAction as F } from "../../../../../hooks/useCommitAction/types.js";
const S = ({
  onChange: i,
  editAction: l,
  onValueUpdated: o,
  selectedCurrencies: y,
  availableCurrencies: I,
  value: M,
  ...u
}) => {
  const { i18n: r } = N(), [n, c] = v(
    m(u.minAmount) ? void 0 : parseFloat(u.minAmount) / b
  ), [t, d] = v(
    m(u.maxAmount) ? void 0 : parseFloat(u.maxAmount) / b
  ), f = x(() => {
    i({ minAmount: n, maxAmount: t });
  }, [t, n, i]), A = x(() => {
    i({ minAmount: void 0, maxAmount: void 0 }), d(void 0), c(void 0);
  }, [i]);
  T(() => {
    l === F.APPLY && f(), l === F.CLEAR && A();
  }, [f, A, l]);
  const g = h(() => ({ minAmount: Number(n), maxAmount: Number(t) }), [t, n]);
  return T(() => {
    const { maxAmount: e, minAmount: s } = g;
    m(e) && m(s) || s > e ? o(null) : o(`${s}-${e}`);
  }, [g, o]), /* @__PURE__ */ a("div", { className: "adyen-pe-range-selection-filter", children: [
    /* @__PURE__ */ a("div", { className: "adyen-pe-range-selection-filter__input", children: [
      /* @__PURE__ */ a("label", { htmlFor: "minValue", children: `${r.get("from")}:` }),
      /* @__PURE__ */ a(
        p,
        {
          "data-testid": "minValueFilter",
          lang: r.locale,
          name: "minValue",
          type: "number",
          value: n,
          onInput: (e) => {
            e.currentTarget && c(e.currentTarget.value !== "" ? e.currentTarget.value : void 0);
          },
          min: 0,
          isInvalid: n ? n < 0 : !1,
          errorMessage: r.get("noNegativeNumbersAllowed")
        }
      )
    ] }),
    /* @__PURE__ */ a("div", { className: "adyen-pe-range-selection-filter__input", children: [
      /* @__PURE__ */ a("label", { htmlFor: "maxValue", children: `${r.get("to")}:` }),
      /* @__PURE__ */ a(
        p,
        {
          "data-testid": "maxValueFilter",
          lang: r.locale,
          name: "maxValue",
          type: "number",
          value: t,
          onInput: (e) => {
            e.currentTarget && d(e.currentTarget.value !== "" ? e.currentTarget.value : void 0);
          },
          min: n,
          isInvalid: !m(t) && !m(n) && t < n,
          errorMessage: r.get("toValueShouldBeGreaterThanTheFromValue")
        }
      )
    ] })
  ] });
};
export {
  S as RangeSelection
};
